export type ProgramSimple = {
    key: string;
    authorNickname: string;
    authorKaid: string | null | undefined;
    spinoffCount: number;
    sumVotesIncremented: number;
    thumb: string;
    translatedTitle: string | null | undefined;
    url: string;
};

// NOTE(tonydinh): With peer evaluations deprecated, Projects and Challenges share
// a similar state progression: NOT_STARTED -> STARTED -> COMPLETE. It would
// be nice to combine these status codes. Though, this would require a backfill
// and for clients to understand both sets of codes for a while.
// NOTE: PROJECT_NOT_STARTED is likely unused. Now that Projects no longer rely
// on spin-offs to track progress, both Projects and Challenge seem to default
// to a -1 challangeStatus to represent an UNSTARTED state.
// sync-start:program-challenge-status 393851895 https://github.com/Khan/webapp/blob/master/services/progress/models/user_program.go
export const PROGRAM_STATUS = Object.freeze({
    CHALLENGE_NOT_STARTED: -1,
    CHALLENGE_STARTED: 0,
    CHALLENGE_COMPLETE: 1,
    PROJECT_NOT_STARTED: 2,
    PROJECT_STARTED: 3,
    PROJECT_PASS: 5,
});
// sync-end:program-challenge-status

export type ProgramStatus =
    (typeof PROGRAM_STATUS)[keyof typeof PROGRAM_STATUS];
